import { Component, OnInit } from '@angular/core';
import { OrgService } from '../_services/org.service';
import { Subscription, combineLatest } from 'rxjs';
import { PhaseService } from '../_services/phase.service';
import { Classroom } from 'src/app/dropdown-classroom/org.classroom';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from 'src/app/_helpers/roles';

@Component({
	selector: 'app-dashboard-admin',
	templateUrl: './dashboard-area.component.html',
})
export class DashboardAreaComponent implements OnInit {
	subscriptions: Subscription[] = [];
	selectedSchool: any;
	phases: any;
	classrooms: Classroom[];
	selectedClassroom: Classroom;
	nodes: any;
	selectedNode: any;
	node: any;
	constructor(public orgService: OrgService, public phaseService: PhaseService, private jwtHelper: JwtHelperService) {}

	ngOnInit(): void {
		this.orgService.init();
		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				console.log('selectedSchool', data);
				this.selectedSchool = data;
			})
		);
		this.subscriptions.push(
			this.orgService.classrooms$.subscribe((data: Classroom[]) => {
				this.classrooms = data;
				console.log('this.classrooms', this.classrooms);
			})
		);
		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: Classroom) => {
				this.selectedClassroom = data;
				console.log('selectedClassroom', this.selectedClassroom);
			})
		);

		//decode token and get header node
		const decodedToken = this.jwtHelper.decodeToken(localStorage.getItem('currentUser'));
		console.log('decodedToken', decodedToken);
		if (decodedToken && decodedToken.attachedNode) {
			this.node = decodedToken.attachedNode;
			console.log('node', this.node);
			this.subscriptions.push(
				this.orgService.tree$(this.node.id).subscribe((data: any) => {
					this.nodes = [data];
					if (this.nodes.length > 0) {
						this.nodes[0].expanded = true;
					}
					console.log('nodes', this.nodes);
				})
			);
		}
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
	nodeChange(node: any) {
		console.log('node', node);
		this.selectedNode = node;

		if (!node || !this.orgService.orgs) {
			return;
		}

		// When a school is selected in tree, update the dropdown
		if (node.typeId == '6') {
			const matchingSchool = this.orgService.orgs.schools?.find((school: any) => school.id == node.id);
			if (matchingSchool) {
				this.orgService.setSchool(matchingSchool);
			}
		}
	}
}
